import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const SmallCreditCardIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 60 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.666504" width="60" height="40" rx="4" fill="#F0F3FB" />
      <path d="M39 14.25H21C20.5858 14.25 20.25 14.5858 20.25 15V27C20.25 27.4142 20.5858 27.75 21 27.75H39C39.4142 27.75 39.75 27.4142 39.75 27V15C39.75 14.5858 39.4142 14.25 39 14.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M33.75 24.75H36.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M29.25 24.75H30.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M20.25 18.0845H39.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(SmallCreditCardIcon);
